// extracted by mini-css-extract-plugin
export default {"dateContainer":"FestivalDate_dateContainer__PEq4P","dateText":"FestivalDate_dateText__FCvQL"};